import { Enrollment } from '@clear-denver/tpc-openapi-typescript'

export const preEnrollmentWithAppointmentBooked: Enrollment.Enrollment = {
  id: 'ee20b0d6-b4ce-497a-89b0-4c0fa900937f',
  applicationId: 'SKHR-XDV7',
  planSelection: {
    key: 'tpc-pre-enroll-5-plan',
    description: 'TSA PreCheck™ - 5 Year Plan',
    services: [
      {
        key: 'tpc-enroll-5',
        description: 'TSA PreCheck™ - 5 Year Plan',
        price: 75,
      },
    ],
    price: 75,
  },
  eligibility: {
    eligibleForMembership: true,
  },
  citizenship: {
    birthCountry: 'US',
    birthLocality: 'Austin',
    birthSubdivision: 'TX',
    citizenshipCountry: 'US',
    nonImmigrantVisaStatus: null,
  },
  documentCheck: {
    photoId: 'DLU',
    document: 'PPE',
    namesOnDocumentsMatch: true,
  },
  biographicInfo: {
    firstName: 'Rich',
    middleName: 'John',
    noMiddleName: false,
    lastName: 'Smith',
    suffix: null as never,
    gender: 'male',
    dateOfBirth: new Date('1950-01-27'),
  },
  attributes: {
    previousNames: [],
    aliases: [],
    eyeColor: 'BLK',
    hairColor: 'BAL',
    heightFeet: 7,
    heightInches: 2,
    weightPounds: 123,
  },
  identityHints: {
    everUsedPreviousName: false,
    everUsedAlias: false,
  },
  addresses: {
    mailingAddress: {
      country: 'US',
      lineOne: '100 Joker Street',
      lineTwo: 'Unit J',
      locality: 'Austin',
      subdivision: 'TX',
      postalCode: '78766',
    },
    useDifferentResidentialAddress: false,
    residentialAddress: null as never,
    atCurrentAddressMoreThanFiveYears: true,
    previousAddress: null as never,
  },
  legal: {
    usCitizenOrNationalOrLPR: false,
    disqualifyingFelonyPartA: false,
    disqualifyingFelonyPartB: false,
    releasedFromIncarcerationPartB: false,
    wantedOrUnderIndictment: false,
    mentalCapacityLegalHistory: false,
  },
  documents: {
    linkingDocExpectedCount: 0,
    uploadedFiles: [],
  },
  finalized: {
    enrollmentLocationId: 'SP1235',
  },
  ssn: null as never,
  clearPromotionsOptIn: null as never,
  agreements: {
    termsAndConditions: false,
    certifyAccurateData: false,
    promotionalMarketing: false,
    guardianAuthorization: false,
  },
  paymentInfo: null as never,
}
